import { makeStyles } from '@soil-capital/ui-kit/style';

export default makeStyles()((theme) => ({
    crossed: {
        textDecoration: 'line-through',
        paddingRight: theme.spacing(1),
    },
}));
